import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3febe013"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "py-5",
  "data-aos": "fade-left"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "title is-2 has-text-centered" }, "My Recent Work", -1))
const _hoisted_3 = { class: "columns is-variable is-1-mobile is-0-tablet is-3-desktop is-multiline mb-5" }
const _hoisted_4 = {
  class: "card container-image",
  "data-aos": "fade-right"
}
const _hoisted_5 = { class: "container-image__background" }
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = { class: "card-content" }
const _hoisted_8 = { class: "title is-6 has-text-weight-bold" }
const _hoisted_9 = { class: "is-size-7 mb-2 description" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "title is-2 has-text-centered" }, "Other projects", -1))
const _hoisted_12 = { class: "columns is-variable is-1-mobile is-0-tablet is-3-desktop is-multiline" }
const _hoisted_13 = {
  class: "card container-image",
  "data-aos": "fade-right"
}
const _hoisted_14 = { class: "container-image__background" }
const _hoisted_15 = { class: "drop-down-window px-3 is-flex is-align-items-center is-justify-content-center has-small-text has-text-black" }
const _hoisted_16 = ["src", "alt"]
const _hoisted_17 = { class: "card-content" }
const _hoisted_18 = { class: "title is-6 has-text-weight-bold" }
const _hoisted_19 = { class: "is-size-7 mb-2 description" }
const _hoisted_20 = ["href"]

import { useStore } from "../store/projects";
import router from "@/router";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectsLine',
  setup(__props) {

const store = useStore();
const otherProjects = store.otherProjects;
const projects = store.projects;

const viewProjectDetails = (id: string) => {
  router.push(`/project/${id}`);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(projects), (project, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "column is-half-tablet is-one-quarter-desktop",
          key: index
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("figure", _hoisted_5, [
              _createElementVNode("img", {
                class: "container-image__background--image",
                src: require(`@/assets/${project.image}`),
                alt: project.image_alt
              }, null, 8, _hoisted_6)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("p", _hoisted_8, _toDisplayString(project.title), 1),
              _createElementVNode("p", _hoisted_9, _toDisplayString(project.description), 1),
              _createElementVNode("button", {
                class: "button is-hoverable is-small",
                onClick: ($event: any) => (viewProjectDetails(project.id))
              }, " View Details ", 8, _hoisted_10)
            ])
          ])
        ]))
      }), 128))
    ]),
    _hoisted_11,
    _createElementVNode("div", _hoisted_12, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(otherProjects), (project, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "column is-half-tablet is-one-quarter-desktop",
          key: index
        }, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("figure", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, _toDisplayString(project.techStack), 1),
              _createElementVNode("img", {
                class: "container-image__background--image",
                src: require(`@/assets/${project.image}`),
                alt: project.image_alt
              }, null, 8, _hoisted_16)
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("p", _hoisted_18, _toDisplayString(project.title), 1),
              _createElementVNode("p", _hoisted_19, _toDisplayString(project.description), 1),
              _createElementVNode("a", {
                class: "button is-hoverable is-small",
                href: project?.site,
                target: "_blank"
              }, " Go to web ", 8, _hoisted_20)
            ])
          ])
        ]))
      }), 128))
    ])
  ]))
}
}

})